<template>
  <div class="mini-tab-content">
    <div
      v-if="loadingNotes"
      class="interc-loading"
    >
      <b-spinner
        small
        variant="secondary"
      />
      <span>Carregando...</span>
    </div>
    <template v-else>
      <div class="interc-toolbar">
        <span class="interc-toolbar__title">
          <feather-icon
            icon="MessageSquareIcon"
            size="13"
            class="mr-25 text-secondary"
          />
          {{ notes.length ? notes.length + ' anotação(ões)' : 'Nenhuma anotação' }}
        </span>
      </div>

      <!-- Composer inline -->
      <div class="form-group mb-2">
        <textarea
          v-model="newContent"
          class="form-control"
          rows="2"
          placeholder="Escreva uma anotação..."
          maxlength="5000"
        />
        <div class="d-flex justify-content-end mt-1">
          <button
            class="btn btn-sm btn-primary"
            :disabled="saving || !newContent.trim()"
            @click="addNote"
          >
            <b-spinner
              v-if="saving"
              small
              class="mr-25"
            />
            <feather-icon
              v-else
              icon="PlusIcon"
              size="13"
              class="mr-25"
            />
            Adicionar
          </button>
        </div>
      </div>

      <div
        v-if="!notes.length"
        class="interc-empty"
      >
        <feather-icon
          icon="MessageSquareIcon"
          size="26"
        />
        <p>Nenhuma anotação registrada.</p>
      </div>

      <div
        v-if="notes.length"
        class="interc-list"
      >
        <div
          v-for="n in notes"
          :key="n.id"
          :class="['interc-item', { 'interc-item--cancelled': n.cancelled_at }]"
        >
          <div class="interc-item__top">
            <div class="interc-item__badge">
              <feather-icon
                :icon="n.cancelled_at ? 'XCircleIcon' : 'MessageSquareIcon'"
                size="11"
                class="mr-25"
              />
              Anotação
            </div>
            <button
              v-if="!n.cancelled_at"
              class="interc-item__del"
              title="Cancelar anotação"
              @click="cancelNote(n.id)"
            >
              <feather-icon
                icon="Trash2Icon"
                size="13"
              />
            </button>
          </div>
          <p
            class="interc-item__desc"
            style="white-space: pre-wrap"
          >
            {{ n.content }}
          </p>
          <div class="interc-item__meta">
            <feather-icon
              icon="UserIcon"
              size="11"
            />
            <span>{{ n.user ? n.user.name : '—' }}</span>
            <span class="interc-item__dot" />
            <feather-icon
              icon="ClockIcon"
              size="11"
            />
            <span>{{ n.created_at | formatDate }}</span>
          </div>
          <div
            v-if="n.cancelled_at"
            class="interc-item__cancelled-row"
          >
            <feather-icon
              icon="XCircleIcon"
              size="11"
              class="mr-25"
            />
            Cancelado por
            <strong>{{ n.cancelled_by ? n.cancelled_by.name : '—' }}</strong>
            · {{ n.cancelled_at | formatDate }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import involvedPanelMixin from './involvedPanelMixin'

export default {
  name: 'NotesPanel',
  mixins: [involvedPanelMixin],
  data() {
    return {
      notes: [],
      loadingNotes: false,
      saving: false,
      newContent: '',
    }
  },
  mounted() {
    this.loadNotes()
  },
  methods: {
    async loadNotes() {
      this.loadingNotes = true
      try {
        const res = await this.$http.get(`${this.$store.state.api}involved_notes`, {
          params: { occurrence_involved_id: this.occurrenceInvolvedId },
        })
        this.notes = res.data.data || res.data || []
      } catch (e) {
        this.notes = []
      } finally {
        this.loadingNotes = false
      }
    },
    async addNote() {
      if (!this.newContent.trim()) return
      this.saving = true
      try {
        const res = await this.$http.post(`${this.$store.state.api}involved_notes`, {
          occurrence_involved_id: this.occurrenceInvolvedId,
          content: this.newContent.trim(),
        })
        const saved = res.data.data || res.data
        this.notes.unshift(saved)
        this.newContent = ''
        this.$message('Anotação registrada', 'Anotação salva com sucesso.', 'success')
      } catch (e) {
        this.$message('Erro', 'Erro ao registrar anotação.', 'error')
      } finally {
        this.saving = false
      }
    },
    async cancelNote(id) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        'A anotação ficará marcada como cancelada e será mantida no histórico. Deseja continuar?',
        {
          title: 'Cancelar anotação', okTitle: 'Sim, cancelar', cancelTitle: 'Voltar', okVariant: 'danger', centered: true, size: 'sm',
        },
      )
      if (!confirmed) return
      try {
        const res = await this.$http.delete(`${this.$store.state.api}involved_notes/${id}`)
        const updated = res.data.data || res.data
        const idx = this.notes.findIndex(n => n.id === id)
        if (idx !== -1) this.$set(this.notes, idx, updated)
      } catch (e) {
        this.$message('Erro', 'Erro ao cancelar anotação.', 'error')
      }
    },
  },
}
</script>
